'use strict';

export { default as CSSKeyframesRuleImpl } from "./CSSKeyframesRuleImpl.js";
//# sourceMappingURL=index.js.map